module.exports = __webpack_public_path__ + "img/cl.599a9ddf.svg";